import type { ReactNode } from 'react';
import React from 'react';
import type { GovEmptyProps } from '@gov-design-system-ce/react';
import { GovEmpty } from '@gov-design-system-ce/react';
import { LayoutGap } from '@gov-nx/ui/web';

export interface EmptyMessageProps extends Omit<GovEmptyProps, 'children'> {
	image?: string;
	imageWidth?: number;
	imageHeight?: number;
	children?: ReactNode;
}

export const EmptyMessage = ({
	headline,
	image,
	children,
	className,
	align,
	imageWidth,
	imageHeight,
	...props
}: EmptyMessageProps) => (
	<GovEmpty
		headline={headline ? <p slot="headline">{headline}</p> : null}
		align={align ? align : 'center'}
		size="s"
		className={className}
		{...props}>
		<LayoutGap
			gap="l"
			className={align ? '' : 'items-center'}>
			{image ? (
				<img
					src={`assets\\images\\${image}.svg`}
					width={imageWidth ? imageWidth : 103}
					height={imageHeight ? imageHeight : 64}
					alt=""
				/>
			) : null}
			<LayoutGap
				gap="m"
				className={align ? '' : 'items-center'}>
				{children}
			</LayoutGap>
		</LayoutGap>
	</GovEmpty>
);
